import $ from 'jquery'
import { gsap, Power2 } from "gsap"
import CSSRulePlugin from "gsap/CSSRulePlugin"
import { SplitText } from "gsap/SplitText"
import { CustomEase } from "gsap/CustomEase"
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(CustomEase)
gsap.registerPlugin(SplitText)
gsap.registerPlugin(ScrollTrigger)

import ScrollMagic from 'scrollmagic'
import { ScrollMagicPluginIndicator} from "scrollmagic-plugins"
ScrollMagicPluginIndicator(ScrollMagic)


/* POST PIN HEADER
  ----------------------------- */
export const postPinHeader = () => {
  const C = new ScrollMagic.Controller()
  const D = $('.post__left-column').innerHeight() - $('.post__main-info').innerHeight() - 64

  if ($(window).width() > 832) {
    new ScrollMagic.Scene({
      triggerElement: '.post.type-post',
      triggerHook: 0,
      duration: D
    })
    .setPin('.post__main-info')
    // .addIndicators()
    .addTo(C)
  }
}

/* PRODUCT PIN HEADER
  ----------------------------- */
export const productPinHeader = () => {
  if ($('.product__left').innerHeight() >= $('.product__right').innerHeight()) {
    const C = new ScrollMagic.Controller()
    let D = $('.product__left').innerHeight() - $('.product__right').innerHeight()

    if ($(window).width() > 832) {
      var myScene = new ScrollMagic.Scene({
        triggerElement: '.product.type-product',
        triggerHook: 0,
        duration: D
      })
      .setPin('.product__right')
      // .addIndicators()
      .addTo(C)
      
      $('.accordion').on('click', function() {
        setTimeout(function() {
          let D = $('.product__left').innerHeight() - $('.product__right').innerHeight()
          myScene.duration(D)
        },500)
      })
    }
  }
}

/* ARCHIVE PIN HEADER
  ----------------------------- */
export const postArchivePinHeader = () => {
  if ($('.section__main-content').innerHeight() >= $('.section__sidebar').innerHeight()) {
    var C = new ScrollMagic.Controller()
    var D = $('.section__main-content').innerHeight() - $('.section__sidebar').innerHeight()

    if ($(window).width() > 832) {
      var myScene = new ScrollMagic.Scene({
        triggerElement: '.section--archive-content',
        triggerHook: 0,
        duration: D
      })
      .setPin('.section__sidebar')
      // .addIndicators()
      .addTo(C)
    }
  }
}

/* ARCHIVE PIN POST
  ----------------------------- */
export const archivePinPost = () => {
  const C = new ScrollMagic.Controller()
  
  if ($(window).width() > 832) {
    if ($('.section__wrapper-first').length > 0) {
      const D1 = $('.section__wrapper-first').innerHeight() - $('.section__item-1').innerHeight()

      new ScrollMagic.Scene({
        triggerElement: '.section__wrapper-first',
        triggerHook: .16,
        duration: D1
      })
      .setPin('.section__item-1')
      // .addIndicators()
      .addTo(C)
    }
    
    if ($('.section__wrapper-second').length > 0) {
      const D2 = $('.section__wrapper-second').innerHeight() - $('.section__item-8').innerHeight()
      
      new ScrollMagic.Scene({
        triggerElement: '.section__wrapper-second',
        triggerHook: .16,
        duration: D2
      })
      .setPin('.section__item-8')
      // .addIndicators()
      .addTo(C)
    }
  }
}

/* PAGE FORM PIN HEADER
  ----------------------------- */
export const pageFormPinHeader = () => {
  const C = new ScrollMagic.Controller()

  if ($(window).width() > 832) {
    $('.section__form-wrapper').each(function() {
      const offset = $('.section__form-wrapper').length > 2 ? 120 : 0
      const D = $(this).find('.section__right').innerHeight() - $(this).find('.section__left').innerHeight() - offset

      if ($(window).width() > 832) {
        new ScrollMagic.Scene({
          triggerElement: this,
          triggerHook: .16,
          duration: D
        })
        .setPin($(this).find('.section__left')[0])
        // .addIndicators()
        .addTo(C)
      }
    })
  }
}

/* ARCHIVE DOCUMENTS PIN HEADER
  ----------------------------- */
export const archiveDocumentsPinHeader = () => {
  const C = new ScrollMagic.Controller()
  const D = $('.section__right').innerHeight() - $('.section__left').innerHeight()

  if ($(window).width() > 832) {
    new ScrollMagic.Scene({
      triggerElement: '.section__content-wrapper',
      triggerHook: .16,
      duration: D
    })
    .setPin('.section__left')
    // .addIndicators()
    .addTo(C)
  }
}

/* OPEN POSITION PIN TOOL
  ----------------------------- */
export const openPositionPinTool = () => {
  const C = new ScrollMagic.Controller()
  const D = $('.op__container').innerHeight() - 500

  if ($(window).width() > 832) {
    new ScrollMagic.Scene({
      triggerElement: '.op__container',
      triggerHook: .1,
      duration: D
    })
    .setPin('.op__tools')
    // .addIndicators()
    .addTo(C)
  }
}

/* EVENT PIN TOOL
  ----------------------------- */
export const eventPinTool = () => {
  const C = new ScrollMagic.Controller()
  const D = $('.event__container').innerHeight() - 500

  if ($(window).width() > 832) {
    new ScrollMagic.Scene({
      triggerElement: '.event__container',
      triggerHook: .1,
      duration: D
    })
    .setPin('.event__tools')
    // .addIndicators()
    .addTo(C)
  }
}

/* TITLE ANIMATION
  ----------------------------- */
export const titleAnimation = () => {
  var split = new SplitText('.title-animation', {type: "lines", linesClass: "line line++"})
  $('.title-animation').css('opacity',1)
  $('.title-animation .line').wrap('<div class="line-wrapper">')
  
  gsap.to(split.lines, {y: 0, duration: 1, ease: "power3.out", stagger: .25})
}

/* WORK HERO ANIMATION
  ----------------------------- */
export const workHeroAnim = () => {
  const videoFull = $('.section__video-full-wrapper .section__video')
  const tl = gsap.timeline({ paused: true })
  tl.to('.section__video-full-wrapper', { yPercent: 100, duration: 1.2, ease: "power2.inOut" })
  tl.to('.section__video-stage', { margin: 0, borderRadius: 0, duration: .35 })
  tl.to('.section__video-full', { alpha: 1, duration: .5 })
  tl.to('.section__video-close,.section__video-controls-wrapper', { alpha: 1, duration: .25 }, "-=.25")

  $('.section__video-trigger').on('click', function() {
    tl.play()
    setTimeout(function () { 
      videoFull.trigger('play')
      $('body').addClass('overflow-hidden')
    }, tl.duration() * 1000 - 500)
  })

  $('.section__video-close').on('click', function() {
    tl.reverse()
    setTimeout(function () { 
      videoFull.trigger('pause').get(0).currentTime = 0
      $('body').removeClass('overflow-hidden')
    }, tl.duration() * 1000 - 1500)
  })
}

/* WORK ANIMATION
  ----------------------------- */
export const setupWorkAnimation = () => {
  if ($(window).width() < 650) {
    $('.section--work-identity .section__image-wrapper').scrollLeft($(window).width())
  }
 
  gsap.to('.section--work-identity .section__image-wrapper', {
    autoAlpha: 1,
    duration: 0.3,
    ease: Power2.easeInOut,
    scrollTrigger: {
      trigger: '.section--work-identity .section__image-wrapper',
      start: "top 50%",
      toggleActions: 'play none play none',
      once: true,
    }
  })

  gsap.to('.section--work-identity .section__image-wrapper figure', { 
    x: 0, 
    scale: 1, 
    duration: 2.6, 
    delay: 0.3,
    ease: Power2.easeInOut,
    scrollTrigger: {
      trigger: '.section--work-identity .section__image-wrapper',
      start: "top 50%",
      toggleActions: 'play none play none',
      once: true,
    } 
  })

  gsap.to('.section--work-identity .section__image-wrapper', { 
    maxWidth: '100%',
    duration: 2.6, 
    delay: 0.6, 
    ease: Power2.easeInOut,
    scrollTrigger: {
      trigger: '.section--work-identity .section__image-wrapper',
      start: "top 50%",
      toggleActions: 'play none play none',
      once: true,
    } 
  })

  const sectionWorksItems = gsap.utils.toArray('.section--work-standard .section__item')
  sectionWorksItems.forEach(function (item, index) {
    gsap.from(item, {
      scrollTrigger: {
        trigger: item,
        start: "top 90%",
        //toggleActions: "play pause reverse reset",
      },
      autoAlpha: 0,
      transformOrigin: "top top",
      duration: 1.5,
      ease: Power2.easeOut,
      toggleActions: 'play none play none',
      once: true,
    })
  })

  var imageAfter = CSSRulePlugin.getRule(".section--work-horizons .section__image-wrapper figure:after")
  gsap.to(imageAfter, {
    scrollTrigger: {
      trigger: '.section--work-horizons .section__image-wrapper',
      start: "top 80%",
      //toggleActions: "play pause reverse reset",
    },
    autoAlpha: 0,
    width: '0%',
    duration: 1,
    ease: Power2.easeOut,
    toggleActions: 'play none play none',
    once: true,
  })

  var imageLab = $(".section--work-lab .section__image-wrapper figure")
  gsap.to(imageLab, {
    scrollTrigger: {
      trigger: '.section--work-lab .section__image-wrapper',
      start: "top 65%",
    },
    autoAlpha: 1,
    scale: 1,
    duration: 2,
    ease: Power2.easeOut,
    toggleActions: 'play none play none',
    once: true,
  })
}

/* MENU ANIMATION
  ----------------------------- */
export const animationMenu = () => {
  var timeline = gsap.timeline()
  timeline.to("#wrapper-megamenu", { duration: 1, y: 0, opacity: 1, }, 0)

  if ($(window).width() > 832) {
    const menu_items = gsap.utils.toArray('.menu--primary .menu-item')
    let index = 0.3
    menu_items.forEach(menu_item => {
      gsap.from(menu_item, {
        duration: 0.5,
        y: -200,
      }, index)
      index = index + 0.16
    })
  
    const service_items = gsap.utils.toArray('.header__service-item')
    let service_index = 1.5
    service_items.forEach(service_item => {
      gsap.from(service_item, {
        duration: 0.7,
        y: -150,
      }, service_index)
      service_index = service_index + 0.16
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/animation.js